import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';  
import { AppSettings } from '@app/common/app-setting';
import { ConcatePath } from '@app/common/utils';
// import { HttpService } from '../../services/base-services/http.service';
// import { HttpService } from '../../services/base-services/http.service';

export abstract class BaseEndPointService {
    protected static BaseApiUrl = AppSettings.API_ENDPOINT + 'api/';
    get BaseApiUrl() {
        return BaseEndPointService.BaseApiUrl;
    }
    protected readonly EndPointUrl: string;
    protected Http: HttpClient;
    constructor(http: HttpClient, path: string) {
        this.Http = http;
        this.EndPointUrl = this.ConcatePath(this.BaseApiUrl, path);
    }

    protected GetQueryString(obj) {
        let qStr = '?';
        if (obj) {
            Object.keys(obj).forEach(a => {
                if (qStr !== '?') {
                    qStr += '&';
                }
                qStr += this.resolveArrayObject(obj[a], a);
            });
        }
        return qStr;
    }
    private resolveArrayObject(obj: any, key: string): string {
        if (obj instanceof Array) {
            if (obj.length === 0) {
                return '';
            }
            return obj.reduce((a, b) => `${a}${a === '' ? '' : '&'}${key}=${b}`, '');
        }
        return key + '=' + obj;
    }
    protected ConcatePath(...paths: string[]) {
        return ConcatePath(...paths);
    }
}




// WEBPACK FOOTER //
// ./src/app/services/base-service/base-endpoint.service.ts